import { motion } from "framer-motion";
import { Button } from "@/components/ui/button";
import { LINKS } from "@/data/content";
import { fadeUp, staggered } from "@/lib/motion";
import { useFlodeskForm } from "@/hooks/useFlodeskForm";

const CareersCard = () => (
  <motion.div
    id="careers"
    data-testid="careers-card"
    {...fadeUp}
    className="flex flex-col bg-midnight px-5 py-14 text-white sm:px-8 sm:py-20 lg:pr-12 lg:pl-[max(2rem,calc((100vw-72rem)/2+2rem))]"
  >
    <div>
      <h2 className="font-heading text-3xl font-bold tracking-tight sm:text-4xl">Careers</h2>
      <p className="mt-4 font-heading text-lg font-semibold sm:text-xl text-white/90">Looking for your next role?</p>
      <p className="mt-5 max-w-sm pb-8 text-base leading-relaxed text-white/70">
        We partner with growing companies across the globe. Browse the roles PKR is hiring for right now.
      </p>
    </div>
    <Button asChild data-testid="careers-cta-loxo" className="mt-auto h-12 self-start bg-white px-6 text-base font-medium text-navy hover:bg-mist active:scale-95">
      <a href={LINKS.careers} target="_blank" rel="noopener noreferrer">
        View open positions
      </a>
    </Button>
  </motion.div>
);

const FLODESK_FORM_ID = "68f0ce8e84eff5a8617b9064";

const FLODESK_HOSTED_URL = `https://view.flodesk.com/forms/${FLODESK_FORM_ID}`;

const NewsletterCard = () => {
  const { containerId, fallback } = useFlodeskForm(FLODESK_FORM_ID);

  return (
    <motion.div
      id="newsletter"
      data-testid="newsletter-card"
      {...staggered(fadeUp, 1, 0.12)}
      className="flex flex-col bg-white px-5 py-14 sm:px-8 sm:py-20 lg:pl-12 lg:pr-[max(2rem,calc((100vw-72rem)/2+2rem))]"
    >
      <h2 className="font-heading text-3xl font-bold tracking-tight sm:text-4xl text-ink">Your Hiring Edge</h2>
      <p className="mt-4 font-heading text-lg font-semibold sm:text-xl text-navy">Short. Sweet. Zero BS.</p>
      <p className="mt-4 text-base leading-relaxed text-ink/65">
        Kelly's monthly hiring insights, the candid advice most recruiters won't share, delivered straight to your inbox.
      </p>
      <div id={containerId} data-testid="newsletter-flodesk-form" className="mt-6" />
      {fallback && (
        <Button asChild data-testid="newsletter-fallback-link" className="btn-primary mt-6 h-12 px-6 text-base">
          <a href={FLODESK_HOSTED_URL} target="_blank" rel="noopener noreferrer">Subscribe</a>
        </Button>
      )}
    </motion.div>
  );
};

export const CareersNewsletter = () => (
  <section data-testid="careers-newsletter-section" className="scroll-mt-24">
    <div className="grid lg:grid-cols-2">
      <CareersCard />
      <NewsletterCard />
    </div>
  </section>
);
